import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	slackWorkspaceConnectionRemovedSuccessFlagTitle: {
		id: 'servicedesk-incident-management-settings.services.actions.remove-slack-workspace-connection.slack-workspace-connection-removed-success-flag-title',
		defaultMessage: 'Workspace successfully removed',
		description: 'The title for successful removal of workplace',
	},
	slackWorkspaceConnectionRemovedSuccessFlagText: {
		id: 'servicedesk-incident-management-settings.services.actions.remove-slack-workspace-connection.slack-workspace-connection-removed-success-flag-text',
		defaultMessage: 'You can re-connect a workspace at anytime',
		description: 'The message content for successful removal of workplace',
	},
	slackWorkspaceConnectionRemovedErrorFlagTitle: {
		id: 'servicedesk-incident-management-settings.services.actions.remove-slack-workspace-connection.slack-workspace-connection-removed-error-flag-title',
		defaultMessage: "We couldn't remove the workspace",
		description: 'The title for error in removal of workplace',
	},
	slackWorkspaceConnectionRemovedErrorFlagText: {
		id: 'servicedesk-incident-management-settings.services.actions.remove-slack-workspace-connection.slack-workspace-connection-removed-error-flag-text',
		defaultMessage: 'Wait a moment or refresh the page before trying again',
		description: 'The message content for error in removal of workplace',
	},
});
